import React from 'react';
export function ComponentPlaceholder({ title }) {
    return (React.createElement("div", { className: "cq-placeholder", "data-emptytext": title }));
}
